import { styled } from "@mui/material/styles";
import { Button, Table, TableCell, TableContainer } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext";
import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const LotoTable = styled(Table)(({theme}) => {
  return {
    width: '100%',
    tableLayout: 'auto',
    [theme.breakpoints.up('xl')]: {
      tableLayout: 'fixed',
    }
  };
});

export const CustomTableBody = styled(TableBody)(() => ({
  ".MuiTableCell-root": {
    fontSize: "1rem !important",
    [desktop]: {
      fontSize: "0.75rem !important",
    },
    [mobile]: {
      fontSize: "0.70rem !important",
    },
  },
  [tablet]: {
    ".MuiTablePagination-displayedRows": {
      fontSize: "0.75rem !important",
    },
    ".MuiTablePagination-selectLabel": {
      fontSize: "0.75rem!important",
    },
  },
}));

export const Cell = styled(TableCell)(() => {
  return {
    borderTop: `1px solid #E0E0E0`,
    borderBottom: "none",
  };
});

export const ContainerDiv = styled('div')(() => {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    width: 'inherit'
  }
})

export const StickyColumn = styled(TableCell)(({ direction }) => {
  const { colors } = useColors();
  
  return {
    position: 'sticky',
    [direction]: 0,
    background: colors.white,
    width: "auto",
    borderTop: `1px solid #E0E0E0`,
    borderBottom: "none",
    borderRight: direction === "left" && `1px solid #E0E0E0`,
    borderLeft: direction === "right" && `1px solid #E0E0E0`,
  }
})

export const HeaderCell = styled(TableCell)(() => {
  const { colors } = useColors();
  return {
    background: colors.white,
    zIndex: "9",
    border: "none",
    fontSize: "1rem",
    fontWeight: 600,
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    alignItems: "center",
    padding: "0 16px",
    color: colors.buttonActionColor,
    "& .MuiButtonBase-root": {
      position: "unset",
    },
    "&:hover": {
      color: colors.buttonActionColor,
      opacity: 0.9,
    },
    [desktop]: {
      fontSize: "0.75rem !important",
    },
  };
});

export const ContainerItem = styled('div')(({ show }) => {
  return {
    display: show === false ? 'none' : null,
    padding: '5px',
    width: 'max-content',
    fontWeight: "bold",
  }
})

export const CustomLink = styled("span")(() => {
  return {
    cursor: "pointer"
  };
});

export const CustomBox = styled(Box)(() => {
  return {
    width: "100%",
    marginTop: "16px",
    [mobile]: {
      marginTop: "16px",
    },
  };
});

export const ContainerActions = styled("div")(() => {
  return {
    display: "flex",
    justifyContent: "center",
    justifyItems: "center",
    gap: 6
  };
});

export const CustomTableContainer = styled(TableContainer)(() => {
  return {
    height: "calc(100vh - 340px)",
  };
});

export const DownloadButton = styled(Button)(() => {
  return {
    width: "8rem",
    padding: "4px",
    fontSize: "0.8rem !important",
    [mobile]: {
      width: "8rem",
      padding: "4px 6px"
    }
  };
});
